module.exports = __webpack_public_path__ + "img/pending-payments.cd0afb6e.svg";